/* meliora trust band + contact/quote  (2026-08-10) part 2/2
   modal + toast + init. Loaded after meliora-trust-forms.js. */
(function () {
  'use strict';
  var N = window.__MLR = window.__MLR || {};
  var overlay = null, holder = null, activeSrc = null;

  N.ensureOverlay = function () {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'meliora-modal-overlay';
    overlay.innerHTML =
      '<div class="meliora-modal" role="dialog" aria-modal="true">' +
        '<button type="button" class="meliora-modal-close" aria-label="閉じる">&times;</button>' +
        '<h3 class="meliora-modal-title"></h3>' +
        '<div class="meliora-modal-prod"></div>' +
        '<div class="meliora-modal-holder"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    holder = overlay.querySelector('.meliora-modal-holder');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) N.closeModal(); });
    overlay.querySelector('.meliora-modal-close').addEventListener('click', N.closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('on')) N.closeModal();
    });
  };

  N.openModal = function (kind) {
    N.ensureOverlay();
    N.refreshSku();
    var src = document.getElementById(kind === 'quote' ? 'meliora-form-quote' : 'meliora-form-inquiry');
    if (!src) return;
    activeSrc = src;
    overlay.querySelector('.meliora-modal-title').textContent = (kind === 'quote' ? '法人お見積り依頼' : 'この商品についてのお問い合わせ');
    overlay.querySelector('.meliora-modal-prod').innerHTML =
      '<span class="mmp-name">' + N.escapeHtml(N.PRODUCT.title) + '</span>' +
      (N.PRODUCT.sku ? '<span class="mmp-sku">品番: ' + N.escapeHtml(N.PRODUCT.sku) + '</span>' : '');
    holder.appendChild(src);
    src.style.display = 'block';
    overlay.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
  };

  N.closeModal = function () {
    if (!overlay) return;
    overlay.classList.remove('on');
    document.documentElement.style.overflow = '';
    if (activeSrc) {
      activeSrc.style.display = '';
      var src = document.getElementById('meliora-forms-src');
      if (src) src.appendChild(activeSrc);
      activeSrc = null;
    }
  };

  N.successToast = function () {
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('contact_posted') !== 'true') return;
      var t = document.createElement('div');
      t.className = 'meliora-toast';
      t.textContent = 'お問い合わせを送信しました。ありがとうございます。担当者より折り返しご連絡いたします。';
      document.body.appendChild(t);
      setTimeout(function () { t.classList.add('on'); }, 50);
      setTimeout(function () { t.classList.remove('on'); }, 6500);
      q.delete('contact_posted');
      var qs = q.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) {}
  };

  N.init = function () {
    if (!document.getElementById('product')) return;
    N.loadProduct();
    N.buildTrust();
    N.buildQuoteBtn();
    N.buildInquiryBtn();
    if (N.cleanTags) N.cleanTags();
    N.successToast();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', N.init);
  } else {
    N.init();
  }
})();
